import { makeAutoObservable } from 'mobx'
import { type IGlobalAlert } from 'shared/ui/Banner'
import { Banner } from 'shared/ui/Banner/model/Banner'

class BannerStore {
  private _itemsMap: Map<string, Banner> = new Map()
  private _disabledGlobal = false

  constructor() {
    makeAutoObservable(this)
  }

  get items() {
    return Array.from(this._itemsMap.values())
  }

  get disabledGlobal() {
    return this._disabledGlobal
  }

  setDisabledGlobal = (disabledGlobal: boolean) => {
    this._disabledGlobal = disabledGlobal
  }

  get = (id: string) => {
    return this._itemsMap.get(id)
  }

  add = (item: IGlobalAlert) => {
    this._itemsMap.set(item.id, new Banner(item))
  }

  remove = (id: string) => {
    this._itemsMap.delete(id)
  }

  removeAll = () => {
    this._itemsMap.clear()
  }

  dispose = () => {
    this.clearLocalStorage()
    this.removeAll()
  }

  clearLocalStorage = () => {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i)

      if (!key) return
      if (/^alert_banner_hide(.+)/.test(key)) {
        window.localStorage.removeItem(key)
      }
    }
  }
}

export const bannerStore = new BannerStore()
